import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import sage from "../../../images/splash/sage.jpeg";
import Nav from 'react-bootstrap/Nav';
import {Navbar,NavDropdown} from 'react-bootstrap';
import { Card, Form, Button, Table } from 'react-bootstrap';
import pro from "../../../images/splash/prof.png";
import axios from "axios";
import { var_api } from "../../constant";
import Modal from 'react-bootstrap/Modal';
import Loader from "../Loader";
import Pagination from 'react-js-pagination';
import React, { useState, useEffect,useRef } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import { Step } from '@material-ui/core';

const ServiceEmployeeSalary = () => {
  const [roleName, setRoleName] = useState('');
  const [roleDescription, setRoleDescription] = useState('');
  const [totalEmployees, setTotalEmployee] = useState([]);
  const [employees, setEmployee] = useState([]);
  const [editMode, setEditMode] = useState(false);
  const [show, setShow] = useState(false);
  const [roleToDelete, setRoleToDelete] = useState(null);
  const [isLogin, setIsLogin] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 10; 
   const [totalItems, setTotalItems] = useState(0);
  const [startIndex, setStartIndex] = useState(0);
  const [ searchQuery,setSearchQuery] = useState('');
  const [roles, setRoles] = useState([]);
  const history = useHistory();
  const [employeeid, setEmployeeid] = useState('');
  const [selectDate, setSelectDate] = useState('');
  const [selectedEmployee, setSelectedEmployee] = useState('');
  const [selectedRoleName, setSelectedRoleName] = useState('');
  const [errors, setErrors] = useState({});
  const [additionalpayment, setAdditionalpayment] = useState('');
  const [bonus, setBonus] = useState(''); 
  const [basicsalary, setBasicSalary] = useState('');
  const [remarks, setRemarks] = useState('');



  useEffect(() => {
    fetchEmployeename();
    fetchEmployeeData();
}, [searchQuery, currentPage]);

const fetchEmployeename = async () => {
  const token = localStorage.getItem('token');
  setIsLogin(true);
  try {
      const response = await axios.get(`${var_api}/api/employee/emp-details`, {
          headers: {
              'Authorization': `${token}`
          }
      });
      setRoles(response.data);
      
      setIsLogin(false);
  } catch (error) {
      setRoles([]);
      if (error.response && error.response.status === 401) {
        history.push('/signin');
      } else {
        Swal.fire({
          icon: 'error',
          title: 'Oops...',
          text: error.response?.data?.error || 'Something went wrong!',
          confirmButtonColor: '#007500',
        });
      }
  }
};
const fetchEmployeeData = async () => {
  const token = localStorage.getItem('token');
  const startIndexCalc = (currentPage - 1) * itemsPerPage;
  const endIndex = startIndexCalc + itemsPerPage;
  setIsLogin(true);
  try {
    const response = await axios.get(`${var_api}/api/employee-salary/get`, {
      headers: {
        'Authorization': `${token}`,
      },
    });
    setTotalEmployee(response.data);
    setIsLogin(false);
  } catch (error) {
    setTotalEmployee([]);
    if (error.response && error.response.status === 401) {
      history.push('/signin');
    } else {
      Swal.fire({
        icon: 'error',
        title: 'Oops...',
        text: error.response?.data?.error || 'Something went wrong!',
        confirmButtonColor: '#007500',
      });
    }
    setEmployee([]);
    setIsLogin(false);
  }
};

const validateForm = () => {
  const newErrors = {};

  if (!selectDate) newErrors.selectDate = 'Select Date is required';
  if (!selectedEmployee) newErrors.selectedEmployee = 'Employee Name is required';
  if (!additionalpayment) newErrors.additionalpayment = 'Additional Payment is required';
  if (!bonus) newErrors.bonus = 'Bonus is required';
  if (!basicsalary) newErrors.basicsalary = 'Basic Salary is required';
  if (!remarks) newErrors.remarks = 'Remarks are required';

  return newErrors;
};

// Helper function to format date as dd-mm-yyyy
const formatDate = (date) => {
  const d = new Date(date);
  const day = String(d.getDate()).padStart(2, '0');
  const month = String(d.getMonth() + 1).padStart(2, '0');
  const year = d.getFullYear();
  return `${day}-${month}-${year}`;
};


const createEmployee = async () => {

  const newErrors = validateForm();
  setErrors(newErrors); // Update the state with validation errors

  // If there are errors, don't proceed with the form submission
  if (Object.keys(newErrors).length > 0) {
    return;
  }
  // Calculate total salary
  const totalSalary = parseInt(basicsalary) + parseInt(bonus) + parseInt(additionalpayment);

  // Prepare the payload
  const payload = {
    any_advance: parseInt(additionalpayment),
    basic_salary: parseInt(basicsalary),
    bonus: parseInt(bonus),
    remarks: remarks,
    salary_date: formatDate(selectDate), // Ensure `selectDate` is in the correct format (e.g., "07-11-2024")
    selected_employee: parseInt(selectedEmployee),
    total_salary: totalSalary,
  };

  // Retrieve token from localStorage
  const token = localStorage.getItem('token');

  try {
    const response = await axios.post(`${var_api}/api/employee-salary/post`, payload, {
      headers: {
        Authorization: `${token}`,
      },
    });

    console.log('Response:', response.data);

    // Show success message and reset the form if needed
    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Employee salary details submitted successfully!',
    });
    fetchEmployeeData();
    resetForm();  // Reset form fields after submission
  } catch (error) {
    console.error('Error submitting data:', error);
    Swal.fire({
      icon: 'error',
      title: 'Submission Failed',
      text: 'There was an error submitting the data.',
    });
  }
};


const updateEmployee = async () => {
  const payload = {
    any_advance: additionalpayment,
    basic_salary: basicsalary,
    bonus: bonus,
    created_at: new Date().toISOString(),  // Set to current date/time or a predefined value
    id: employeeid,                         // Assuming `employeeId` holds the current employee's ID
    name: selectedRoleName,
    remarks: remarks,
    salary_date: formatDate(selectDate),
    selected_employee: selectedEmployee,
    total_salary: calculateTotalSalary(),   // Call a function or set a value to determine total salary
    updated_at: new Date().toISOString()    // Automatically set to the current date/time
  };

  try {
    const response = await axios.put(`${var_api}/api/employee-salary/put/${employeeid}`, payload, {
      headers: {
        Authorization: `${localStorage.getItem('token')}`,
      },
    });
    console.log('Update Response:', response.data);

    Swal.fire({
      icon: 'success',
      title: 'Success',
      text: 'Employee salary details updated successfully!',
    });
    resetForm();   // Clear the form after successful update
    fetchEmployeeData();
  } catch (error) {
    console.error('Error updating data:', error);
    Swal.fire({
      icon: 'error',
      title: 'Update Failed',
      text: 'There was an error updating the employee data.',
    });
  }
};

// Helper function to calculate total salary if needed
const calculateTotalSalary = () => {
  return parseFloat(basicsalary) + parseFloat(bonus) + parseFloat(additionalpayment);
};


const handleOpenConfirmation = (employeeId) => {
    setRoleToDelete(employeeId);
    setShow(true);
};

const handleCloseConfirmation= ()=>{
    setShow(false)
  };
  const resetForm = () => {
    setSelectDate('');         // Resets the date input
    setSelectedEmployee('');    // Resets the employee selection
    setAdditionalpayment('');   // Resets additional payment input
    setBonus('');               // Resets bonus input
    setBasicSalary('');         // Resets basic salary input
    setRemarks('');             // Resets remarks input
    setErrors({});              // Clears any error messages
    setEditMode(false);         // Exits edit mode if it was active
  };
  

const handleDelete = async () => {
    const token = localStorage.getItem('token');
    setIsLogin(true);
    try {
        await axios.delete(`${var_api}/api/employee-salary/delete/${roleToDelete}`, {
            headers: {
                'Authorization': `${token}`
            }
        });
        console.log('Role deleted successfully!');
        fetchEmployeeData();
        handleCloseConfirmation();
        setIsLogin(false);
    } catch (error) {
        console.error('Error deleting role:', error);
        if (error.response && error.response.status === 401) {
            history.push('/signin');
        }
    }
};


const handleEdit = (employee) => {
  // Ensure date is formatted as YYYY-MM-DD if valid
  let formattedDate = "";
  if (employee.salary_date) {
    const [day, month, year] = employee.salary_date.split("-");
    formattedDate = `${year}-${month}-${day}`;
  }

  setSelectDate(formattedDate);
    setEditMode(true);
    setAdditionalpayment(employee.any_advance);
    setBonus(employee.bonus);
    setBasicSalary(employee.basic_salary); // Leave password empty for security
    setRemarks(employee.remarks);
    setSelectedEmployee(employee.selected_employee);
    setEmployeeid(employee.id);
    setSelectedRoleName(employee.name);
  };

  const handleSearchInput = (e) => {
    setSearchQuery(e.target.value);
    setCurrentPage(1);
  };
  
  // Filter employees before applying pagination
  const filteredEmployees = Array.isArray(totalEmployees) && totalEmployees.filter(employee => {
    const searchLower = searchQuery.toLowerCase();
    return (
      (employee.emp_name?.toString().toLowerCase().includes(searchLower) || "") ||
      (employee.salary_date?.toString().toLowerCase().includes(searchLower) || "") ||
      (employee.any_advance?.toString().toLowerCase().includes(searchLower) || "") ||
      (employee.bonus?.toString().toLowerCase().includes(searchLower) || "") ||
      (employee.basic_salary?.toString().toLowerCase().includes(searchLower) || "") ||
      (employee.total_salary?.toString().toLowerCase().includes(searchLower) || "") ||
      (employee.remarks?.toString().toLowerCase().includes(searchLower) || "") 
    );
  });
  
  // Apply pagination to the filtered list
  const paginatedFilteredEmployees = filteredEmployees.slice((currentPage - 1) * itemsPerPage, currentPage * itemsPerPage);
  

     // Handler to update state when a role is selected
     const handleRoleChange = (e) => {
      const roleId = e.target.value;
      const roleName = e.target.options[e.target.selectedIndex].text;
  
      setSelectedEmployee(roleId);
      setSelectedRoleName(roleName);
    };

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber); // Update current page
  };

  const totalSalarySum = totalEmployees.reduce((sum, employee) => sum + parseFloat(employee.total_salary || 0), 0);

    return(
        <>
        {isLogin && <Loader />}
        <Navbar bg="light" expand="md" className="bg-body-tertiary" collapseOnSelect fixed="top">
  <Navbar.Brand href="#home">
    <img src={sage} alt="logo" className="img-fluid" style={{ maxWidth: "200px", margin: "3px 80px" }} />
  </Navbar.Brand>
  <Navbar.Toggle aria-controls="responsive-navbar-nav" />
  <Navbar.Collapse id="responsive-navbar-nav">
  <Nav className="mx-auto">
      <Nav.Link href="#" style={{ color: "black", fontSize:"25px", letterSpacing:"2px" }}>
       EMPLOYEE SALARY 
      </Nav.Link>
    </Nav>
    <Nav className="ms-auto">
      <Nav.Link href="/sb-home" style={{ color: "black", fontSize: "15px" }}>
        <button className="btn" style={{backgroundColor:"rgb(89, 128, 71)", color:"white"}}>
          <i className="bi bi-house"></i> Go to home
        </button>
      </Nav.Link>
    </Nav>
  </Navbar.Collapse>
</Navbar>
<br/>
<br/>
<br/>
<br/>
         <div style={{margin:"auto",padding:"20px"}}>
             <Row>
             <Col xs={12} md={6} lg={6} xl={4} xxl={4}>
             <Card style={{ border: "none", maxWidth: "28rem", padding: "15px 27px", margin: "auto", height: "auto", borderRadius: "20px", boxShadow: "rgba(0, 0, 0, 0.16) 0px 3px 6px, rgb(89, 128, 71, 0.50) 0px 3px 6px" }}>
            <Card.Body>
                <h5 style={{ textAlign: "center", color: "rgb(89, 128, 71)", fontWeight: "bold" }}>{editMode ? 'Edit Employee Salary' : 'Create Employee Salary'}</h5>
                <Form onSubmit={(e) => e.preventDefault()}>
                <Form.Group controlId="formBasicName" className="mt-3">
  <Form.Label>Select Date</Form.Label>
  <Form.Control
    type="date"
    placeholder="Select Date"
    name="selectDate"
    value={selectDate || ""}  // Fallback to an empty string if selectDate is undefined
    onChange={(e) => setSelectDate(e.target.value)}
    required
  />
  {errors.selectDate && <p style={{ color: 'red' }}>{errors.selectDate}</p>}
</Form.Group>


                    <Form.Group controlId="formBasicEmail" className="mt-3">
        <Form.Label>Select Employee</Form.Label>
        <Form.Control
          as="select"
          name="selectedEmployee"
          value={selectedEmployee}
          onChange={handleRoleChange}
          required
        >
          <option value="">Select Employee</option>
          {roles.map((role, index) => (
            <option key={index} value={role.id}>
              {role.name}
            </option>
          ))}
        </Form.Control>
        {errors.selectedEmployee && <p style={{ color: 'red' }}>{errors.selectedEmployee}</p>}
      </Form.Group>

                    <Form.Group controlId="formBasicEmail" className="mt-3">
                        <Form.Label>Additional Payment</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Additional Payment"
                            name="additional"
                            value={additionalpayment}
                            onChange={(e) =>  setAdditionalpayment(e.target.value)}
                            required
                        />
                        {errors.additionalpayment && <p style={{ color: 'red' }}>{errors.additionalpayment}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mt-3">
                        <Form.Label>Bonus</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Bonus"
                            name="bonus"
                            value={bonus}
                            onChange={(e) =>  setBonus(e.target.value)}
                            required
                        />
                        {errors.bonus && <p style={{ color: 'red' }}>{errors.bonus}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicPassword" className="mt-3">
                        <Form.Label>Basic Salary</Form.Label>
                        <Form.Control
                            type="number"
                            placeholder="Enter Basic Salary"
                            name="basic salary"
                            value={basicsalary}
                            onChange={(e) =>  setBasicSalary(e.target.value)}
                            required
                        />
                         {errors.basicsalary && <p style={{ color: 'red' }}>{errors.basicsalary}</p>}
                    </Form.Group>

                    <Form.Group controlId="formBasicProfile" className="mt-3">
                        <Form.Label>Remarks</Form.Label>
                        <Form.Control
                            type="text"
                            placeholder="Enter Remarks"
                            name="profile"
                            value={remarks}
                            onChange={(e) =>  setRemarks(e.target.value)}
                            required
                        />
                    </Form.Group>

                    {/* <Button variant="primary" type="submit" className="mt-3" style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }} onClick={employeeMasterpost}>
                        {editMode ? 'Update' : 'Submit'}
                    </Button>{" "} */}
                     <Button
      variant="primary"
      type="button"
      className="mt-3"
      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
      onClick={createEmployee}
      hidden={editMode}  // This will hide the Submit button when editMode is true
    >
      Submit
    </Button>{" "}

    <Button
      variant="primary"
      type="button"
      className="mt-3"
      style={{ backgroundColor: "rgb(89, 128, 71)", color: "white", borderColor: "rgb(89, 128, 71)" }}
      onClick={() => updateEmployee()}
      hidden={!editMode}  // This will hide the Update button when editMode is false
    >
      Update
    </Button>{" "}

                    <Button variant="danger" type="button" className="mt-3" onClick={resetForm}>
                        Reset
                    </Button>
                </Form>
            </Card.Body>
        </Card>
</Col>
                <Col xs={12} md={6} lg={6} xl={8} xxl={8} style={{padding:"0px",margin:"0px"}}>
                <Card style={{ border: "none", maxWidth:"62rem", padding:"20px", margin:"auto", height:"auto", borderRadius:"20px", fontFamily:"Arial, Helvetica, sans-serif" }}>
                 <h5 style={{color:"rgb(89, 128, 71)", fontWeight:"bold"}}>Employee Salary Summary<span style={{float:"right", fontSize:"17px", color:"black", fontWeight:"bold"}}><Form.Control type="text" placeholder="Search..."  onChange={handleSearchInput}/></span> </h5>  
                 <div style={{float:"left"}}>
                 <span style={{fontSize:"17px", color:"rgba(50, 103, 19)"}}>Total Salary: {totalSalarySum}</span>
                    </div> 
        <Table responsive className="mt-3">
          <thead>
            <tr>
              <th>S.No</th> 
              <th>Name</th>
              <th>Date</th>
              <th>Additional Payment</th>
              <th>Bonus</th>
              <th>Basic Salary</th>
              <th>Total Salary</th>
              <th>Remarks</th>
              <th>Action</th>
            </tr>
          </thead>
          <tbody>
  {paginatedFilteredEmployees.length > 0 ? (
    paginatedFilteredEmployees.map((employee, index) => (
      <tr key={employee.id}>
        <td>{startIndex + index + 1}</td>
        <td>{employee.emp_name}</td>
        <td>{employee.salary_date}</td>
        <td>{employee.any_advance}</td>
        <td>{employee.bonus}</td>
        <td>{employee.basic_salary}</td>
        <td>{employee.total_salary}</td>
        <td>{employee.remarks}</td>
        <td>
          <div className="d-flex align-items-center">
            {/* <Button variant="success" className="m-1" onClick={() => handleMessage(employee)}>
              <i className="bi bi-chat-left-dots"></i>
            </Button> */}
            <Button variant="primary" className="m-1" onClick={() => handleEdit(employee)}>
              <i className="bi bi-pencil-square"></i>
            </Button>
            <Button variant="danger" className="m-1" onClick={() => handleOpenConfirmation(employee.id)}>
              <i className="bi bi-trash"></i>
            </Button>
          </div>
        </td>
      </tr>
    ))
  ) : (
    <tr>
      <td colSpan="10" className="text-center">No data available</td>
    </tr>
  )}
</tbody>
</Table>
<Pagination
  activePage={currentPage}
  itemsCountPerPage={itemsPerPage}
  totalItemsCount={filteredEmployees.length} // Update total count to reflect filtered data
  pageRangeDisplayed={5}
  onChange={handlePageChange}
  itemClass="page-item"
  linkClass="page-link"
  innerClass="pagination justify-content-end"
  activeClass="active-pagination"
/>
      </Card>
                </Col>
            </Row>
        </div>
        <Modal
        show={show}
        onHide={handleCloseConfirmation}
        backdrop="static"
        keyboard={false}
        size="md" // Set size to large
        style={{ borderRadius: '20px' }} // Add border radius style
      >
        <Modal.Header closeButton style={{backgroundColor:"rgba(103, 120, 95, 0.367)",padding:"12px"}}>
          <Modal.Title  style={{fontFamily:"serif",fontWeight:"bolder",marginLeft:"190px"}}>Confirm Delete</Modal.Title>
        </Modal.Header>
        <Modal.Body>

         <div style={{padding:"20px",backgroundColor:"white"}}>
          <h6 className='text-dark' style={{textAlign:"center",fontWeight:"bolder"}}>Are You Sure You want to Delete ?</h6> 
         </div>
         {' '} 
          <Button variant="danger" style={{float:"right"}} onClick={handleCloseConfirmation}>
            Close
          </Button>{' '} 
          <Button variant="success" style={{float:"right",marginRight:"5px"}} onClick={handleDelete}>
            Confirm
          </Button>
        </Modal.Body>
      </Modal>
        </>
    )
}

export default ServiceEmployeeSalary;